import { render, staticRenderFns } from "./emitir_etiqueta.vue?vue&type=template&id=0c6d5d16&"
import script from "./emitir_etiqueta.vue?vue&type=script&lang=js&"
export * from "./emitir_etiqueta.vue?vue&type=script&lang=js&"
import style0 from "./emitir_etiqueta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports